// A Wrapper for the <FormControl>, <InputLabel>, <Error> and the Stripe <*Element>.
// Similar to Material UI's <TextField>. Handles focused, empty and error state
// to correctly show the floating label and error messages etc.

import * as React from 'react'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

import StripeInput from './StripeInput'

interface IStripeElementWrapperProps {
  component: React.ComponentType
  label: string
  helpText?: string
}

interface IStripeError {
  message: string
  code: string
  type: string
}

interface IStripeElementWrapperState {
  focused?: boolean
  empty?: boolean
  error?: IStripeError
  helpText?: string
}
export default class StripeElementWrapper extends React.PureComponent<
  IStripeElementWrapperProps,
  IStripeElementWrapperState
> {
  public readonly state: IStripeElementWrapperState = {
    focused: false,
    empty: true
  }

  public render() {
    const { component, label, helpText } = this.props
    const { focused, empty, error } = this.state
    const hasError = error !== undefined

    return (
      <div>
        <FormControl fullWidth margin="normal">
          <InputLabel
            required
            focused={focused}
            shrink={focused || !empty}
            error={hasError}>
            {label}
          </InputLabel>
          <Input
            required
            fullWidth
            error={hasError}
            inputComponent={StripeInput}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            inputProps={{ component }}
          />
          {hasError && <FormHelperText error>{error!.message}</FormHelperText>}
          {helpText && <FormHelperText>{helpText}</FormHelperText>}
        </FormControl>
      </div>
    )
  }

  private handleBlur = () => {
    this.setState({ focused: false })
  }

  private handleFocus = () => {
    this.setState({ focused: true })
  }

  private handleChange = (changeObj: any) => {
    this.setState({
      error: changeObj.error,
      empty: changeObj.empty
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/stripe-mui/StripeElementWrapper.tsx